import React from 'react';

const OpenRolesHeader = ({ 
  totalRoles, 
  filteredRoles, 
  currentView, 
  onViewChange, 
  onExportCSV,
  error 
}) => {
  return (
    <div className="dashboard-card p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        {/* Title and Stats */}
        <div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Open Roles</h1>
          <div className="flex items-center gap-4 text-sm text-gray-600">
            <span className="flex items-center">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
              {filteredRoles} of {totalRoles} roles
            </span>
            {error && (
              <span className="flex items-center text-amber-600">
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
                Using fallback data
              </span>
            )}
          </div>
        </div>

        {/* View Controls and Actions */}
        <div className="flex items-center gap-3">
          {/* View Toggle */}
          <div className="flex bg-gray-100 rounded-lg p-1">
            <button
              onClick={() => onViewChange('kanban')}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                currentView === 'kanban'
                  ? 'bg-white text-primary-color shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
              title="Kanban View"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
              </svg>
            </button>
            <button
              onClick={() => onViewChange('table')}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                currentView === 'table'
                  ? 'bg-white text-primary-color shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
              title="Table View"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </button>
            <button
              onClick={() => onViewChange('cards')}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                currentView === 'cards'
                  ? 'bg-white text-primary-color shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
              title="Cards View"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
              </svg>
            </button>
          </div>

          {/* Export Button */}
          <button
            onClick={onExportCSV}
            disabled={filteredRoles === 0}
            className="flex items-center px-4 py-2 bg-primary-color text-white rounded-lg hover:bg-primary-color-dark disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            title="Export filtered roles to CSV"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Export CSV
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpenRolesHeader;